import { Divider, Heading, Icon, Stack, Text } from "@chakra-ui/react";
import { FaHome, FaHubspot, FaTrash } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { HiDocumentSearch, HiLink } from "react-icons/hi";
import { MdEmail, MdHelp } from "react-icons/md";
import { RiUserSearchFill } from "react-icons/ri";
import DashboardButtons from "../../../components/Buttons/DashboardButtons";

export default function DashboardSupervisor() {
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaHome}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Service Portal</Heading>
                            <Text fontSize={'sm'}>Service Portal Management</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stack
                p={4}
                w={'98%'}
                spacing={4}
                rounded={'xl'}
                boxShadow={'base'}
                divider={<Divider />}
            >
                <Stack
                    spacing={2}
                >
                    <Heading fontSize={'2xl'}>Routine Tasks</Heading>
                    <Stack
                        w={'full'}
                        spacing={4}
                        direction={'row'}
                        justify={'space-between'}
                    >
                        <DashboardButtons
                            Icon={HiDocumentSearch}
                            text={'Document Review'}
                            to={'/internal/documents-review'}
                        />
                        <DashboardButtons
                            Icon={MdEmail}
                            text={'Processed Documents Summary'}
                            to={'/internal/processed-documents-summary'}
                        />
                        <DashboardButtons
                            Icon={MdHelp}
                            text={'Categorization Help'}
                            to={'/internal/categorization-help'}
                        />
                        <DashboardButtons
                            Icon={FaTrash}
                            text={'Deleted Documents'}
                            to={'/internal/deleted-documents'}
                        />
                    </Stack>
                    <Stack
                        w={'full'}
                        spacing={4}
                        direction={'row'}
                        justify={'space-between'}
                    >
                        <DashboardButtons
                            Icon={RiUserSearchFill}
                            text={'User Log'}
                            to={'/internal/users-activity'}
                        />
                        <DashboardButtons
                            Icon={GiWallet}
                            text={'Billing History'}
                            to={'/internal/billing-history'}
                        />
                        <DashboardButtons
                            Icon={HiLink}
                            text={'Integrated Past Data'}
                            to={'/internal/integrated-past-data'}
                        />
                        <DashboardButtons
                            Icon={FaHubspot}
                            text={'Hubspot Sync'}
                            to={'/internal/hubspot-sync'}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}